<template>
  <div class="he-setting-item-box">
    <el-form label-position="right" label-width="140px" size="small" :model="model">
      <slot />
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'ItemBox',
  props: {
    classSuffix: {
      type: String,
      default: 'common'
    },
    model: {
      type: [Object, null],
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.he-setting-item-box{
  padding-top: 10px;
}
</style>
